// extracted by mini-css-extract-plugin
module.exports = {"body":"EmptyList_body__1KmP4","emptyImage":"EmptyList_emptyImage__3y_P9"};